import type { CalloutType } from "@octopusdeploy/design-system-components";
import { Callout } from "@octopusdeploy/design-system-components";
import type { CommunicationStyle } from "@octopusdeploy/octopus-server-client";
import { CommunicationStyleValues, MachineModelHealthStatusValues } from "@octopusdeploy/octopus-server-client";
import React from "react";
import DateFormatter from "~/utils/DateFormatter";
interface MachineHealthStatusCalloutProps {
    communicationStyle: CommunicationStyle;
    healthStatus: string;
    lastChecked: string;
    itemDescription: string;
}
function getHealthStatusCallout(status: string, lastChecked: string, itemDescription: string): [
    CalloutType,
    string,
    React.ReactNode
] {
    const lastCheckedNote = lastChecked ? `Last health check ${DateFormatter.momentAgo(lastChecked)}` : null;
    switch (status) {
        case MachineModelHealthStatusValues.Healthy:
            return ["success", "Healthy", lastCheckedNote];
        case MachineModelHealthStatusValues.Unhealthy:
            return ["danger", "Unhealthy", lastCheckedNote];
        case MachineModelHealthStatusValues.HasWarnings:
            return ["warning", "Healthy with warnings", lastCheckedNote];
        case MachineModelHealthStatusValues.Unavailable:
            return ["danger", "Unavailable", lastCheckedNote];
        case MachineModelHealthStatusValues.Unknown:
            return ["warning", "Unknown", <p>This {itemDescription} was just added, and a health check has not been performed.</p>];
        default:
            throw new Error(`Unknown health status: ${status}`);
    }
}
export function MachineHealthStatusCallout(props: MachineHealthStatusCalloutProps) {
    const { communicationStyle, healthStatus, lastChecked, itemDescription } = props;
    if (communicationStyle === CommunicationStyleValues.None) {
        return (<section>
                <Callout type={"success"} title="Healthy">
                    <p>Cloud Regions are always healthy. Hooray!</p>
                </Callout>
            </section>);
    }
    const [calloutType, calloutTitle, calloutContent] = getHealthStatusCallout(healthStatus, lastChecked, itemDescription);
    return (<section>
            <Callout type={calloutType} title={calloutTitle}>
                {calloutContent}
            </Callout>
        </section>);
}
